/* eslint-disable react-hooks/rules-of-hooks */
import React, { PropsWithChildren, useMemo } from 'react';
import { IocContext } from '@cp/shared/di';
import { isBrowser } from '@cp/utils/browser';
import { Result } from '@youhelp-ru/core';
import { LOGIN_FEATURE_TOKEN, useStartBillingSubscription } from 'src/features/billing';
import { PAYMENT_FEATURE } from 'src/features/dialog';
import { TRY_FOR_FREE } from 'src/features/burgerMenu';
import { NOTIFICATION_UNSUBSCRIBE_FEATURE, QUIZ_FEATURE, REGISTRATION_FEATURE, useAuth } from 'src/features/auth';
import { useRegistrationFeature } from 'src/features/registration';
import { useQuizFeature } from 'src/features/clientSelection';
import { useNotificationUnsubscribe } from 'src/features/notifications';
import { CATALOG_QUIZ } from 'src/features/catalog';
import { CATALOG_ITEM_AUTH_FEATURE } from 'src/features/catalogItem';
import { Container } from '../../ioc';

const NOT_APPLICABLE_SSR = new Error('Not applicable for server rendering');

export const IocContainerProvider = ({ container, children }: PropsWithChildren & { container: Container }) => {
  useMemo(() => {
    container.bind({
      provide: REGISTRATION_FEATURE,
      useFactory: () => (isBrowser ? useRegistrationFeature() : () => Promise.resolve(Result.Err(NOT_APPLICABLE_SSR))),
    });

    container.bind({ provide: CATALOG_ITEM_AUTH_FEATURE, useFactory: () => useAuth() });
    container.bind({ provide: LOGIN_FEATURE_TOKEN, useFactory: () => useAuth() });
    container.bind({ provide: TRY_FOR_FREE, useFactory: () => useStartBillingSubscription()[0] });
    container.bind({ provide: PAYMENT_FEATURE, useFactory: () => useStartBillingSubscription()[0] });
    container.bind({ provide: QUIZ_FEATURE, useFactory: () => useQuizFeature() });
    container.bind({ provide: NOTIFICATION_UNSUBSCRIBE_FEATURE, useFactory: () => useNotificationUnsubscribe() });
    container.bind({ provide: CATALOG_QUIZ, useFactory: () => useQuizFeature() });
  }, [container]);

  return <IocContext value={container}>{children}</IocContext>;
};
